import LinearProgress from '@mui/material/LinearProgress';
import { styled } from '@mui/material/styles';
import { useEffect, useRef, useState } from 'react';

interface LoaderProgressProps {
  isComplete?: boolean; 
}

const Root = styled('div')({
  flexGrow: 1,
  width: '52rem',
  '@media (max-width:599px)': {
    width: '12rem',
  },

  '@media (min-width:600px) and (max-width:1180px)': {
    width: '41rem',
  },
});

const StyledLinearProgress = styled(LinearProgress)({
  backgroundColor: '#dbafaf',
  '& .MuiLinearProgress-bar': {
    backgroundColor: '#00aa8f',
  },
});

const LoaderProgress = ({ isComplete = false }: LoaderProgressProps) => {
  const [completed, setCompleted] = useState(0);
  const timer = useRef<ReturnType<typeof setInterval> | null>(null);

  const clearTimer = () => {
    if (timer.current) {
      clearInterval(timer.current);
      timer.current = null;
    }
  };

  useEffect(() => {
    if (isComplete) {
      clearTimer();
      setCompleted(100);
      return;
    }

    timer.current = setInterval(() => {
      setCompleted((prev) => {
        const remaining = 90 - prev;
        if (remaining <= 0) {
          clearTimer();
          return 90;
        }
        return prev + remaining * 0.1; 
      });
    }, 300);

    return clearTimer;
  }, [isComplete]);

  return (
    <Root>
      <StyledLinearProgress variant="determinate" value={completed} />
      <div className="final__progress-text">{`${Math.ceil(completed)}%`}</div>
    </Root>
  );
};

LoaderProgress.displayName = 'LoaderProgress';

export default LoaderProgress;